import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "mb-5",
  style: {"font-size":"38px","z-index":"10"}
}

import { onMounted, ref, watch } from "vue";
import { LottieAnimation } from "lottie-web-vue";

import Dino from "@/assets/Dino.json";
import BluetoothHeadphones from "@/assets/BluetoothHeadphones.json";
import CloudUplpoad from "@/assets/CloudUpload.json";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePage',
  props: {
  heading: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const route = useRoute();
const path = ref(route.path);

watch(
  () => route.path,
  (newPath) => {
    path.value = newPath;
  },
);

// ---- LOTTIE ----

let anim = ref();
// eslint-disable-next-line no-undef
onMounted(() => {
  setTimeout(() => {
    if (path.value !== "/optimize-signal") {
      console.log(anim.value.goToAndPlay(150, true));
    }
  }, 500);
});

return (_ctx: any,_cache: any) => {
  const _component_VCol = _resolveComponent("VCol")!

  return (_openBlock(), _createBlock(_component_VCol, {
    class: "w-100 h-100 justify-center align-center pa-8 overflow-hidden",
    style: {"background":"#fafafc","overflow":"auto"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VCol, { class: "w-50 justify-center align-center pa-0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(
          path.value !== '/recording' && path.value !== '/finish' ? 'lottie-container' : ''
        ),
            style: {"z-index":"10"}
          }, [
            (path.value !== '/optimize-signal')
              ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                  key: 0,
                  style: {"width":"150px","justify-content":"center","align-items":"center","margin-left":"auto","margin-right":"auto"},
                  ref_key: "anim",
                  ref: anim,
                  "animation-data": 
            path.value === '/recording'
              ? _unref(Dino)
              : path.value === '/finish'
                ? _unref(CloudUplpoad)
                : _unref(BluetoothHeadphones)
          ,
                  loop: true,
                  "auto-play": true,
                  speed: 1
                }, null, 8, ["animation-data"]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("h1", _hoisted_1, _toDisplayString(props.heading), 1),
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})